import React, { useEffect } from "react";
import StudentBanner from "../StudentBanner/StudentBanner";
import StudentForm from "../StudentForm/StudentForm";
import StudentFooter from "../StudentFooter/StudentFooter";
import "./StudentPage.css";

const StudentPage = () => {
  useEffect(() => {
    // StudentPage mount aagumbothu mattum body scroll disable pannurom,
    // idhu double scrollbar fix pannum indha page ku mattum.
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.body.style.height = "100%";
    document.documentElement.style.height = "100%";

    return () => {
      // Unmount aagumbothu (vera page ku navigate pannumbothu) restore pannurom,
      // illana baaki ella pages um scroll aaga matiga.
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      document.body.style.height = "";
      document.documentElement.style.height = "";
    };
  }, []);

  return (
    <div className="student_page_wrapper">
      <section className="student_page_section">
        <StudentBanner />
      </section>
      <section className="student_page_section">
        <StudentForm />
      </section>
      <section className="student_page_section">
        <StudentFooter />
      </section>
    </div>
  );
};

export default StudentPage;